import { useEffect } from 'react';

// Escape cierra el modal activo (/apple-design, modality.md: una salida evidente).
// Si hay un ConfirmDialog encima, él detiene el evento y este no llega a dispararse.
export default function useEscapeKey(active, onClose) {
  useEffect(() => {
    if (!active) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [active, onClose]);
}
